import React from 'react'
import styled from 'styled-components'

interface QuestionContentsContainer {
  row: number
}

const QuestionContentsContainer = styled.div<QuestionContentsContainer>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-height: ${(p) => `calc((64px + 8px) * ${p.row} + 8px)`};
  @media (min-width: 896px) {
    max-height: ${(p) => `calc((144px + 8px) * ${p.row} + 8px)`};
  }
`

const QuestionContents: React.FC<QuestionContentsContainer> = (props) => {
  return (
    <QuestionContentsContainer {...{ row: props.row }}>
      {props.children}
    </QuestionContentsContainer>
  )
}

export default QuestionContents